/**
 * Unified toast API (replaces antd `message.*`).
 * Uses react-toastify already mounted in App (high z-index for dialogs).
 *
 * Mapping: antd message.success/error/info/warning → toast.*
 */
import type { ReactNode } from 'react';
import { toast as rtToast, ToastOptions, Id } from 'react-toastify';

/** Au-dessus des modales MUI / Ant. Parité Settings ToastContainer. */
export const TOAST_Z_INDEX = 100200;

const baseOpts: ToastOptions = {
  position: 'top-center',
  autoClose: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  style: { zIndex: TOAST_Z_INDEX },
};

export const toast = {
  success: (content: ReactNode, durationMs = 4000): Id =>
    rtToast.success(content as string, { ...baseOpts, autoClose: durationMs }),
  error: (content: ReactNode, durationMsOrOpts: number | ToastOptions = 5000): Id => {
    if (typeof durationMsOrOpts === 'number') {
      return rtToast.error(content as string, { ...baseOpts, autoClose: durationMsOrOpts });
    }
    return rtToast.error(content as string, { ...baseOpts, ...durationMsOrOpts });
  },
  info: (content: ReactNode, durationMs = 4000): Id =>
    rtToast.info(content as string, { ...baseOpts, autoClose: durationMs }),
  warning: (content: ReactNode, durationMs = 4000): Id =>
    rtToast.warning(content as string, { ...baseOpts, autoClose: durationMs }),
  loading: (content: ReactNode, _durationMs?: number): Id =>
    rtToast.loading(content as string, { ...baseOpts, autoClose: false }),
  dismiss: (id?: Id) => rtToast.dismiss(id),
  update: rtToast.update,
};

export default toast;
